var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

export var sizesByDensity = {
  comfortable: {
    xxs: '2px',
    xs: '4px',
    s: '8px',
    m: '12px',
    l: '16px',
    xl: '24px',
    xxl: '32px',
    xxxl: '40px'
  },
  compact: {
    xxs: '1px',
    xs: '2px',
    s: '4px',
    m: '8px',
    l: '12px',
    xl: '16px',
    xxl: '24px',
    xxxl: '32px'
  }
};
/**
 * TODO: Add horizontal overrides for comfortable mode as necessary
 */

sizesByDensity.comfortable['horizontal'] = __assign({}, sizesByDensity.comfortable);
/**
 * TODO: Add horizontal overrides for comfortable mode as necessary
 */

sizesByDensity.comfortable['vertical'] = __assign({}, sizesByDensity.comfortable);
/**
 * TODO: Add horizontal overrides for compact mode as necessary
 */

sizesByDensity.compact['horizontal'] = __assign({}, sizesByDensity.compact);
/**
 * TODO: Add vertical overrides for compact mode as necessary
 */

sizesByDensity.compact['vertical'] = __assign({}, sizesByDensity.compact);